import { CircularProgress } from '@mui/material'

import { DigitalTwinSettingMetadata, TranslatedDeviationSetting } from 'api/digitalTwin/digitalTwin.api'
import { Setting } from 'api/settings/settings.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import StatusIcon from 'ui/atoms/StatusIcon/StatusIcon'
import ActiveSettingText from 'ui/components/ActiveSettingText/ActiveSettingText'

// NOTE: Stolen and modified from src\ui\components\CustomTable\components\SettingsStatusField\SettingsStatusField.tsx
type SettingsStatusFieldProps = {
  value:
    | Setting
    | DigitalTwinSettingMetadata
    | TranslatedDeviationSetting
    | null
    | Array<Setting | TranslatedDeviationSetting | null>
  loading?: boolean
}
export default function SettingsStatusField({ value, loading }: SettingsStatusFieldProps): ReactElement {
  const { t } = useTranslation()

  if (loading) {
    return <CircularProgress size={24} />
  }

  if (Array.isArray(value)) {
    if (value.every((v) => v === undefined || v === null)) {
      return (
        <StatusIcon
          variant="settings_no_deviation"
          tooltip={{
            title: t(`No deviation`),
            arrow: true,
            placement: `top`,
          }}
        />
      )
    }
    return (
      <StatusIcon
        variant="settings_deviation"
        tooltip={{
          title: t(`Has deviation`),
          arrow: true,
          placement: `top`,
        }}
      />
    )
  }

  return value?.value === undefined || value?.value === null ? (
    <StatusIcon
      variant="settings_no_deviation"
      tooltip={{
        title: t(`No deviation`),
        arrow: true,
        placement: `top`,
      }}
    />
  ) : (
    <StatusIcon
      variant="settings_deviation"
      tooltip={{
        title: <ActiveSettingText startTime={value.start_time} endTime={value.end_time} />,
        arrow: true,
        placement: `top`,
      }}
    />
  )
}
